import axios, { AxiosResponse } from 'axios'

import { gatewayConfig } from '../feat/gatewayClient/config'
import { bs } from '../state/bound.store'
import { comboInterceptorReqNoAuth } from './interseptors'
import { comboGWInterceptorReq } from './interseptors/comboGWInterceptorReq'
import { comboInterceptorReq } from './interseptors/comboInterceptorReq'
import { comboInterceptorResponse } from './interseptors/comboInterResp'
import { logInterReqError } from './interseptors/logInterReqError'
import { logInterResponse } from './interseptors/logInterResponse'
import { logInterResponseError } from './interseptors/logInterResponseError'

export const instance = axios.create({
    timeout: 30000,
})

export const instanceNoAuth = axios.create({
    timeout: 30000,
})

export const gateWayInstance = axios.create({
    timeout: 30000,
})

// Only use for functions that require a timeout of more than 15s
export const gateWayLongInstance = axios.create({
    timeout: 900000,
})

const instancesGW = [gateWayInstance, gateWayLongInstance]
const instancesWP = [instance]
const instancesWPNoAuth = [instanceNoAuth]

// lets delay this a bit
setTimeout(() => {
    instancesGW.forEach((instance) => {
        instance.interceptors.response.use(
            comboInterceptorResponse,
            logInterResponseError
        )
        instance.interceptors.request.use(
            comboGWInterceptorReq,
            logInterReqError
        )
    })

    instancesWP.forEach((instance) => {
        if (comboInterceptorResponse) {
            instance.interceptors.response.use(
                comboInterceptorResponse,
                logInterResponseError
            )
        }

        instance.interceptors.request.use(comboInterceptorReq, logInterReqError)
    })

    instancesWPNoAuth.forEach((instance) => {
        instance.interceptors.response.use(
            logInterResponse,
            logInterResponseError
        )
        instance.interceptors.request.use(
            comboInterceptorReqNoAuth,
            logInterReqError
        )
    })
}, 10)

// orgId allows to override the selected orgid
export const getBaseUrl = (orgId?: string) => {
    const wp_url = gatewayConfig().baseWPUrl + bs().selectedOrg?.name
    if (orgId) {
        //replace org id in the wp_url from this http://localhost:4300/francerwc  to  http://localhost:4300/orgId
        return (
            wp_url.split('/').slice(0, 3).join('/') + '/' + orgId + '/wp-json/'
        )
    }

    return wp_url + '/wp-json/'
}
export interface IResponseWithHeader<T> {
    data: T
    headers: Record<string, string>
}

export const responseBody = <T>(response: AxiosResponse<T | any>) =>
    response.data

export const responseBodyWithHeaders = <T>(response: AxiosResponse<T>) => {
    return { data: response.data, headers: response.headers }
}

export interface IResponseWithHeader<T> {
    data: T
    headers: Record<string, string>
}
